module.exports = __webpack_public_path__ + "img/notcorrect.c62138b1.png";